module.exports = __webpack_public_path__ + "static/fipcgreystar2-3302d2514425f8822b4bbb55f812de85.jpeg";